export const fields = [
    { key: 'index', label: "No", _style:'min-width:30px'},
    { key: 'name', label: "Nama", _style:'min-width:100px' },
    { key: 'address', label: "Alamat", _style:'min-width:100px' },
    { key: 'created_at', label: "Tanggal Dibuat", _style:'min-width:100px' },
    { key: 'updated_at', label: "Tanggal Diubah", _style:'min-width:100px' },
    { key: "action", label: 'Aksi', _style: 'min-width:75px'}
]
